__turbopack_context__.v({
  "item": "FooterColumn-module-scss-module__KSIhLq__item",
});
